module.exports = __webpack_public_path__ + "static/media/random.0e47f378.svg";